module.exports = __webpack_public_path__ + "7b15ea6688d2076adab59ad3ec83e5ab.jpg";